/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Team_Member_AddedInputs */

const en_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Team Member Added`)
};

const fr_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau membre d'équipe ajouté`)
};

const de_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Teammitglied hinzugefügt`)
};

const it_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiunto nuovo membro del team`)
};

const ru_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В команду добавлен новый член.`)
};

const es_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo miembro del equipo añadido`)
};

const zh_cn2_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新团队成员加入`)
};

const ja_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいチームメンバーが追加されました`)
};

const hi_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम में नया सदस्य शामिल हुआ`)
};

const pt_pt2_options_notifications_team_member_added = /** @type {(inputs: Options_Notifications_Team_Member_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo membro da equipe adicionado`)
};

/**
* | output |
* | --- |
* | "New Team Member Added" |
*
* @param {Options_Notifications_Team_Member_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_team_member_added = /** @type {((inputs?: Options_Notifications_Team_Member_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Team_Member_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_team_member_added(inputs)
	if (locale === "de") return de_options_notifications_team_member_added(inputs)
	if (locale === "it") return it_options_notifications_team_member_added(inputs)
	if (locale === "ru") return ru_options_notifications_team_member_added(inputs)
	if (locale === "es") return es_options_notifications_team_member_added(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_team_member_added(inputs)
	if (locale === "ja") return ja_options_notifications_team_member_added(inputs)
	if (locale === "hi") return hi_options_notifications_team_member_added(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_team_member_added(inputs)
	return en_options_notifications_team_member_added(inputs)
});